import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionService } from 'src/app/services/configuracion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { ProductosService } from 'src/app/services/productos.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';

@Component({
  selector: 'confirmaciongenerica',
  templateUrl: './confirmaciongenerica.component.html',
  styleUrls: ['./confirmaciongenerica.component.scss']
})
export class ConfirmacionGenericaComponent implements OnInit{
  @Input() TituloMostrar: string = 'Confirmaci&oacute;n';
  @Input() MensajeMostrar: string = '&iquest;Est&aacute; seguro de que desea ejecutar la acci&oacute;n?';
  @Input() TextoSiMostrar: string = 'Si';
  @Input() TextoNoMostrar: string = 'No';
  @Input() CodigoLlamado: string = '';
  @Output() ConfirmoUsuario: EventEmitter<boolean>;
  @ViewChild('modalconfirmacion', {static: false}) _ModalConfirmacion: TemplateRef<any>;


  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public configuracionService: ConfiguracionService,
    public modal: MatDialog) {
      this.ConfirmoUsuario = new EventEmitter();
    }

  ngOnInit() {
    
  }

  public MostrarMensajeConfirmacion() {
    let confirmacionModal = this.modal.open(this._ModalConfirmacion);

    confirmacionModal.afterClosed().subscribe(valor => {
      this.ConfirmoUsuario.emit(valor);
    });
  }
}
